"use server";
import axios from "axios";

type TeacherEntry = {
  IdTeacher: number;
  FIO_teacher: string;
};
interface Dictionary {
  [key: number]: string;
}

export async function getTeacherNames() {
  const dict: Dictionary = {};
  console.log("в фнуции");
  const req = `http://schedule.mslu.by/backend/getTeacherNames`;
  let response;
  try {
    response = await axios.get(req);
  } catch (e) {
    console.log(e);
    throw e;
  }
  const data: TeacherEntry[] = response.data.data;
  data.forEach((current) => {
    dict[current.IdTeacher] = current.FIO_teacher;
  });
  return dict;
}
export async function getTeacherSchedule(teacherId: string, weekType: string) {
  const endpoint = `http://schedule.mslu.by/backend/teachers?teacherId=${teacherId}&weekType=${weekType}`;
  let response;
  try {
    response = await axios.get(endpoint);
  } catch (e) {
    console.log(e);
  }
  return response;
}
export function getTeacherId(TeacherList: {}, TeacherFIO: string) {
  if (TeacherFIO === undefined || TeacherFIO === null || TeacherFIO === "") {
    throw "teacher hasn't been selected";
  }
  for (const [key, value] of Object.entries(TeacherList)) {
    if (value == TeacherFIO) {
      return key;
    }
  }
}
export async function AddSchedule(TeacherList: {}, value: string) {
  try {
    const id = await getTeacherId(TeacherList, value);
    if (!id) {
      throw new Error("Teacher ID not found");
    }
    const response = await getTeacherSchedule(id, "fourthWeek");
    const schedule = response?.data.data;
    console.log(schedule);
  } catch (e) {
    console.log(e);
  }
  //   Test_DB();
}
